export { BvlFormCheckboxComponent as BvlFormCheckbox } from './form-checkbox.component';
export { BvlFormCheckboxModule } from './form-checkbox.module';